// Wrapper for @rjsf/validator-ajv8 internal createPrecompiledValidator import.
//
// WARNING: This deep import relies on the internal file layout of
// @rjsf/validator-ajv8 and is not a public API. If the package is upgraded,
// verify this path still exists.
//
// Keep all usages behind this local module so future path changes are isolated.

// eslint-disable-next-line import/no-internal-modules
import createPrecompiledValidator from '@rjsf/validator-ajv8/lib/createPrecompiledValidator';

export default createPrecompiledValidator;